export default {
  生成失败: '生成失败',
  AI总结汇总: 'AI总结汇总',
  AI格式整理失败: 'AI格式整理失败',
  格式整理成功: '格式整理成功',
  'AI排版中...': 'AI排版中...'
};
